module.exports = __webpack_public_path__ + "00c9c67cd392da8a08c17b72c7fd3fbf.svg";